// extracted by mini-css-extract-plugin
export default {"fragment_place_holder":"pdp-fragment_place_holder","invisible_container":"pdp-invisible_container"};